import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    required: {
        color: theme.palette.error.main,
    },
    greyBox: {
        fontStyle: 'inherit',
        backgroundColor: '#EBEBEB',
        borderRadius: '4px',
        border: '1px #EBEBEB',
        padding: '0.5em',
        margin: '0 auto',
        width: '6rem',
    },
    select: {
        padding: '0.5rem',
        border: `2px solid ${theme.palette.grey.main}`,
        borderRadius: '0.3em',
    },
    invalid: {
        extend: 'select',
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
    },
    descriptive: {
        fontStyle: 'italic',
    },
    headerDivider: {
        borderBottom: '1px solid #979797',
        margin: '0.25rem auto 1rem auto',
        width: '65%',
    },
}));
